forms-tasks-deliveries-search
  form.form.row(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.status")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.delivery_options")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.who")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.shipfrom_id")
    .col-12.col-md-2.offset-md-4
      inputs-search-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.tasks-deliveries.search')
